import { useRouter } from 'next/router';
import { node } from 'prop-types';
import React from 'react';
import { QueryParamProvider } from 'use-query-params';

// Make use-query-params work with Next.js
// https://github.com/pbeshai/use-query-params/issues/13#issuecomment-533945423
const QueryProvider = ({ children }) => {
  const router = useRouter();

  const history = {
    push: ({ search }) => router.push({ search, pathname: router.pathname }),
    replace: ({ search }) =>
      router.replace({ search, pathname: router.pathname }),
  };

  const location = {
    search: router.asPath.replace(/[^?]+/u, ''),
  };

  return (
    <QueryParamProvider history={history} location={location}>
      {children}
    </QueryParamProvider>
  );
};

QueryProvider.propTypes = {
  children: node,
};

export default QueryProvider;
